function getRequiredAccess(path) {
  if (path.includes('/financeiro')) return { key: 'financeiro' };
  if (path.includes('/config')) return { key: 'configs' };
  if (path.includes('/notificacoes')) return { key: 'notificacoes' };
  if (path.includes('/locais/add')) return { key: 'locais', create: true };
  if (path.includes('/locais')) return { key: 'locais' };
  if (path.includes('/eventos/add')) return { key: 'eventos', create: true };
  if (path.includes('/eventos') || path.includes('/evento/')) return { key: 'eventos' };
  if (path.includes('/bares/add')) return { key: 'bares', create: true };
  if (path.includes('/bares') || path.includes('/bar/')) return { key: 'bares' };
  if (path.includes('/pedidos')) return { key: 'pedidos' };
  if (path.includes('/comunicacao')) return { key: 'comunicacao' };
  if (path.includes('/suporte')) return { key: 'suporte' };
  if (path.includes('/integracoes')) return { key: 'configs' };

  return { key: 'organizador' };
}

function hasRequiredAccess(permissions, required) {
  const permission = permissions?.[required.key];
  if (!permission?.status) return false;
  if (!required.create) return true;

  return permission.canCreate === true || permission.permissao >= 3;
}

function loginRedirect(path) {
  return `/login?ret=${path.replaceAll('/', '@d@')}`;
}

function deniedRedirect(fullPath) {
  return `/painel/acesso-negado?ret=${encodeURIComponent(fullPath)}`;
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) return;
  if (!to.path.startsWith('/painel/org/') || to.path === '/painel/org/add') return;

  const orgId = to.params.id;
  if (!orgId) return;

  const token = useCookie('token');
  if (!token.value) {
    return navigateTo(loginRedirect(to.path));
  }

  const runtimeConfig = useRuntimeConfig();
  const apidomain = runtimeConfig.public.NUXT_API_BACK_URL;
  const required = getRequiredAccess(to.path);

  try {
    const access = await $fetch(`${apidomain}/organizador/${orgId}/access`, {
      headers: { authorization: `Bearer ${token.value}` }
    });

    if (!hasRequiredAccess(access?.permissions, required)) {
      return navigateTo(deniedRedirect(to.fullPath));
    }
  } catch (err) {
    const statusCode = err?.statusCode || err?.response?.status;

    if (statusCode === 401) {
      return navigateTo(loginRedirect(to.path));
    }

    if (statusCode === 403) {
      return navigateTo(deniedRedirect(to.fullPath));
    }
  }
});
